import api from "./api"

const getAuthHeaders = () => {
  return {
    "x-kongosys-user-id": localStorage.getItem("kongosys_user_id") || "",
    "x-user-id": localStorage.getItem("kongosys_user_id") || "",

    "x-kongosys-role": localStorage.getItem("kongosys_role") || "",
    "x-role": localStorage.getItem("kongosys_role") || "",

    "x-kongosys-company-id": localStorage.getItem("kongosys_company_id") || "1",
    "x-company-id": localStorage.getItem("kongosys_company_id") || "1",

    "x-kongosys-organization-id":
      localStorage.getItem("kongosys_organization_id") || "",
    "x-organization-id": localStorage.getItem("kongosys_organization_id") || "",

    "x-kongosys-organization-code":
      localStorage.getItem("kongosys_organization_code") || "",
    "x-organization-code":
      localStorage.getItem("kongosys_organization_code") || "",

    "x-kongosys-store-id": localStorage.getItem("kongosys_store_id") || "",
    "x-store-id": localStorage.getItem("kongosys_store_id") || "",

    "x-kongosys-warehouse-id":
      localStorage.getItem("kongosys_warehouse_id") || "",
    "x-warehouse-id": localStorage.getItem("kongosys_warehouse_id") || "",
  }
}

const withAuth = (config = {}) => {
  return {
    ...config,
    headers: {
      ...getAuthHeaders(),
      ...(config.headers || {}),
    },
  }
}

const buildActionPayload = (notes = "") => {
  return {
    notes:
      typeof notes === "string" && notes.trim() !== "" ? notes.trim() : null,
  }
}

export const getStockOrderFormData = async () => {
  const response = await api.get("/stock-orders/form-data", withAuth())
  return response.data
}

export const getStockOrders = async (params = {}) => {
  const cleanParams = {}

  if (params.status) cleanParams.status = params.status
  if (params.date_from) cleanParams.date_from = params.date_from
  if (params.date_to) cleanParams.date_to = params.date_to

  const response = await api.get(
    "/stock-orders",
    withAuth({
      params: cleanParams,
    })
  )

  return response.data
}

export const getStockOrderById = async (orderId) => {
  const response = await api.get(`/stock-orders/${orderId}`, withAuth())
  return response.data
}

export const createStockOrder = async (payload) => {
  const response = await api.post("/stock-orders", payload, withAuth())
  return response.data
}

export const approveMaisonDjoStockOrder = async (orderId, notes = "") => {
  const response = await api.post(
    `/stock-orders/${orderId}/approve-maison-djo`,
    buildActionPayload(notes),
    withAuth()
  )

  return response.data
}

export const approveKinMousseStockOrder = async (
  orderId,
  notes = "",
  items = []
) => {
  const response = await api.post(
    `/stock-orders/${orderId}/approve-kin-mousse`,
    {
      notes:
        typeof notes === "string" && notes.trim() !== "" ? notes.trim() : null,
      items,
    },
    withAuth()
  )

  return response.data
}

export const shipStockOrder = async (orderId, notes = "") => {
  const response = await api.post(
    `/stock-orders/${orderId}/ship`,
    buildActionPayload(notes),
    withAuth()
  )

  return response.data
}

export const receiveStockOrder = async (orderId, notes = "") => {
  const response = await api.post(
    `/stock-orders/${orderId}/receive`,
    buildActionPayload(notes),
    withAuth()
  )

  return response.data
}

export const rejectStockOrder = async (orderId, notes = "") => {
  const response = await api.post(
    `/stock-orders/${orderId}/reject`,
    buildActionPayload(notes),
    withAuth()
  )

  return response.data
}